import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../service/requestHandler";

//VM
export const StatusForVulVm = createDynamicThunk(
  "StatusForVulVm",
  "/report/api/v1/vm/CISOComplianceStatusCounts"
);

export const AppliactionForVulVm = createDynamicThunk(
  "AppliactionForVulVm",
  "/report/api/v1/vm/getRequestByApplicationCounts"
);

export const ActionPlanForVulVm = createDynamicThunk(
  "ActionPlanForVulVm",
  "/report/api/v1/vm/getCISOActionPlanCounts"
);

export const TablelistlVm = createDynamicThunk(
  "TablelistlVm",
  "/report/api/v1/vm/cisoVulnerabilitiesList",
  ["pageNumber", "itemsPerPage"],
  "POST"
);

//SHF
export const StatusForVulSHF = createDynamicThunk(
  "StatusForVulSHF",
  "/report/api/v1/securityHub/getRequestByStatusCounts"
);

export const AppliactionForVulShf = createDynamicThunk(
  "AppliactionForVulShf",
  "/report/api/v1/securityHub/getApplicationWiseRequestCount"
);

export const ActionplanForShf = createDynamicThunk(
  "ActionplanForShf",
  "/report/api/v1/securityHub/actionPlanCounts"
);

export const TablelistlSHF = createDynamicThunk(
  "TablelistlSHF",
  `/report/api/v1/securityHub/manageComplianceList`,
  ["pageNumber", "itemsPerPage"],
  "POST"
);

// BSP
export const StatusForVulBSP = createDynamicThunk(
  "StatusForVulBSP",
  "/report/api/v1/awsBspCompliance/CISO/getCountByStatusForBSP"
);

export const ApplicationForVulBSP = createDynamicThunk(
  "ApplicationForVulBSP",
  "/report/api/v1/awsBspCompliance/CISO/appCodeWiseCountForBSP"
);

export const ActionplanForBSP = createDynamicThunk(
  "ActionplanForBSP",
  "/report/api/v1/awsBspCompliance/CISO/actionPlanCountForBSP"
);

export const TablelistlBSP = createDynamicThunk(
  "TablelistlBSP",
  `/report/api/v1/awsBspCompliance/getCISOTableListDataForBSP`,
  ["pageNumber", "itemsPerPage"],
  "POST"
);

export const TableCountSHF = createDynamicThunk("TableCountSHF", "POST");

//TRMG
export const StatusForTRMG = createDynamicThunk(
  "StatusForTRMG",
  "/report/api/v1/conformancePack/CISO/getCountByStatusForTRMG"
);

export const ApplicationFoTRMG = createDynamicThunk(
  "ApplicationFoTRMG",
  "/report/api/v1/conformancePack/CISO/AppCodeWiseCountForTRMG"
);

export const ActionplanFoTRMG = createDynamicThunk(
  "ActionplanFoTRMG",
  "/report/api/v1/conformancePack/CISO/actionPlanCountForTRMG"
);
//C9
export const TablelistTRMG_C9 = createDynamicThunk(
  "TablelistTRMG_C9",
  `/report/api/v1/conformancePack/ListWithSearchAndPagination`,
  ["packName", "pageNumber", "itemsPerPage"],
  "POST"
);

export const TableCountTRMG_C9 = createDynamicThunk(
  "TableCountTRMG_C9",
  "POST"
);

export const StatusForC9 = createDynamicThunk(
  "StatusForC9",
  "/report/api/v1/conformancePack/CISO/getCountByStatusForCircular09"
);

export const ApplicationforC9 = createDynamicThunk(
  "ApplicationforC9",
  "/report/api/v1/conformancePack/CISO/AppCodeWiseCountForCircular09"
);

export const ActionplanForC9 = createDynamicThunk(
  "ActionplanForC9",
  "/report/api/v1/conformancePack/CISO/actionPlanCountForCircular09"
);

//IMI8
export const StatusForIMI8 = createDynamicThunk(
  "StatusForIMI8",
  "/report/api/v1/conformancePack/CISO/getCountByStatusForCircular09"
);

export const ApplicationforIMI8 = createDynamicThunk(
  "ApplicationforIMI8",
  "/report/api/v1/conformancePack/CISO/AppCodeWiseCountForCircular09"
);

export const ActionplanForIMI8 = createDynamicThunk(
  "ActionplanForIMI8",
  "/report/api/v1/conformancePack/CISO/actionPlanCountForCircular09"
);
//RMIT
export const StatusForRMiT = createDynamicThunk(
  "StatusForRMiT",
  "/report/api/v1/awsRMITController/RMIT/CISO/getCountByStatusForRMIT"
);

export const ApplicationFoRMiT = createDynamicThunk(
  "ApplicationFoRMiT",
  "/report/api/v1/awsRMITController/RMIT/CISO/getAppCodeWiseCountForRMIT"
);

export const ActionplanFoRMiT = createDynamicThunk(
  "ActionplanFoRMiT",
  "/report/api/v1/awsRMITController/RMIT/CISO/actionPlanCountForRMIT"
);

export const TablelistRMiT = createDynamicThunk(
  "TablelistRMiT",
  `/report/api/v1/awsRMITController/ListWithSearchAndPaginations`,
  ["packName", "pageNumber", "itemsPerPage"],
  "POST"
);

export const TableCountRMiT = createDynamicThunk("TableCountRMiT", "POST");
//CIS
export const StatusForCIS = createDynamicThunk(
  "StatusForCIS",
  "/report/api/v1/cisBenchMark/CISO/getCountByStatusForCisBenchMark"
);

export const ApplicationforCIS = createDynamicThunk(
  "ApplicationforCIS",
  "/report/api/v1/cisBenchMark/requestByApplicationForCisBenchMark"
);

export const ActionplanForCIS = createDynamicThunk(
  "ActionplanForCIS",
  "/report/api/v1/cisBenchMark/CisBenchmarkActionPlanCounts"
);

export const TablelistlCIS = createDynamicThunk(
  "TablelistlCIS",
  `/report/api/v1/cisBenchMark/cisoVulnerabilityList`,
  ["pageNumber", "itemsPerPage"],
  "POST"
);

export const TableCountCIS = createDynamicThunk("TableCountCIS", "POST");

//OnPremise
export const AppliactionForOnpremise = createDynamicThunk(
  "AppliactionForOnpremise",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForRequestByApplicationForCircular09OnPremises"
);

export const AppliactionForRiskAssessment = createDynamicThunk(
  "AppliactionForRiskAssessment",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForRequestByApplicationForRiskAssessment"
);

export const StatusForOnpremise = createDynamicThunk(
  "StatusForOnpremise",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForRequestAppCodesForCircular09OnPremises"
);

export const StatusForRiskAssessment = createDynamicThunk(
  "StatusForRiskAssessment",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForRequestAppCodesForRiskAssessment"
);

export const ActionplanForonpremiseC9 = createDynamicThunk(
  "ActionplanForonpremiseC9",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForNonComplianceByActionPlanForCircularNineOnPremises"
);

export const ActionplanForonpremiseRA = createDynamicThunk(
  "ActionplanForonpremiseRA",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForNonComplianceByActionPlanForRiskAssessment"
);

export const AppliactionForOnpremiseIMI8 = createDynamicThunk(
  "AppliactionForOnpremiseIMI8",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForRequestByApplicationForCircular09OnPremises"
);

export const StatusForOnpremiseIMI8 = createDynamicThunk(
  "StatusForOnpremiseIMI8",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForRequestAppCodesForCircular09OnPremises"
);

export const ActionplanForonpremiseIMI8 = createDynamicThunk(
  "ActionplanForonpremiseIMI8",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/managementDashboard/getDataForNonComplianceByActionPlanForCircularNineOnPremises"
);

export const OPCisoListApiIMI8 = createDynamicThunk(
  "OPCisoListApiIMI8",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/getWithCircular09CisoListAndPagination",
  ["pageNumber", "itemsPerPage"]
);

export const RACisoListApiIMI8 = createDynamicThunk(
  "RACisoListApiIMI8",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/getWithCircular09CisoListAndPagination",
  ["pageNumber", "itemsPerPage"]
);

export const OPCisoCountAPIIMI8 = createDynamicThunk(
  "OPCisoCountAPIIMI8",
  "/api/v1/CircularNineOnPremisesController/getCircularNineCISOListCount"
);

export const ApproveRejectIMI8Op = createDynamicThunk(
  "ApproveRejectIMI8Op",
  "/riskAssessment/api/v1/riskAssessmentDashboard/managementDashboard/cisoApprovedOrReject"
);

export const getDetailsofOnPremiseIMI8 = createDynamicThunk(
  "getDetailsofOnPremiseIMI8",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getCircularNineOnPremiseCommentList/",
  ["complianceId"],
  "GET"
);

export const OPCisoListApi = createDynamicThunk(
  "OPCisoListApi",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/getWithCircular09CisoListAndPagination",
  ["pageNumber", "itemsPerPage"]
);

export const RACisoListApi = createDynamicThunk(
  "RACisoListApi",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/getWithCircular09CisoListAndPagination",
  ["pageNumber", "itemsPerPage"]
);

export const OPCisoCountAPI = createDynamicThunk(
  "OPCisoCountAPI",
  "/api/v1/CircularNineOnPremisesController/getCircularNineCISOListCount"
);

export const ApproveRejectC9Op = createDynamicThunk(
  "ApproveRejectC9Op",
  "/riskAssessment/api/v1/riskAssessmentDashboard/managementDashboard/cisoApprovedOrReject"
);

export const getDetailsofOnPremise = createDynamicThunk(
  "getDetailsofOnPremise",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getCircularNineOnPremiseCommentList/",
  ["complianceId"],
  "GET"
);

export const initialState = {
  //VM
  StatusForVulVmData: [],
  StatusForVulVmDataLoading: false,
  AppliactionForVulVmData: [],
  AppliactionForVulVmDataLoading: false,
  ActionPlanForVulVmData: [],
  ActionPlanForVulVmDataLoading: false,
  TablelistlVmData: [],
  TablelistlVmDataLoading: false,
  //SHF
  StatusForVulSHFData: [],
  StatusForVulSHFDataLoading: false,
  AppliactionForVulShfData: [],
  AppliactionForVulShfDataLoading: false,
  ActionplanForShfData: [],
  ActionplanForShfDataLoading: false,
  TablelistlSHFData: [],
  TablelistlSHFDataLoading: false,
  TableCountSHFData: [],
  TableCountSHFDataLoading: false,
  //BSP
  StatusForVulBSPData: [],
  StatusForVulBSPDataLoading: false,
  ApplicationForVulBspData: [],
  ApplicationForVulBspDataLoading: false,
  ActionplanForBspData: [],
  ActionplanForBspDataLoading: false,
  TablelistlBSPData: [],
  TablelistlBSPDataLoading: false,
  TableCountBSPData: [],
  TableCountBSPDataLoading: false,
  //TRMG
  StatusForTRMGData: [],
  StatusForTRMGLoading: false,
  ApplicationFoTRMGData: [],
  ApplicationFoTRMGLoading: false,
  ActionplanFoTRMGData: [],
  ActionplanFoTRMGLoading: false,
  TablelistTRMG_C9Data: [],
  TablelistTRMG_C9Loading: false,
  TableCountTRMG_C9Data: [],
  TableCountTRMG_C9Loading: false,
  //C9
  StatusForC9Data: [],
  StatusForC9Loading: false,
  ApplicationforC9Data: [],
  ApplicationforC9Loading: false,
  ActionplanForC9Data: [],
  ActionplanForC9Loading: false,
  //IMI8
  StatusForIMI8Data: [],
  StatusForIMI8Loading: false,
  ApplicationforIMI8Data: [],
  ApplicationforIMI8Loading: false,
  ActionplanForIMI8Data: [],
  ActionplanForIMI8Loading: false,
  //RMIT
  StatusForRMiTData: [],
  StatusForRMiTLoading: false,
  ApplicationFoRMiTData: [],
  ApplicationFoRMiTLoading: false,
  ActionplanFoRMiTData: [],
  ActionplanFoRMiTLoading: false,
  TablelistRMiTData: [],
  TablelistRMiTLoading: false,
  TableCountRMiTData: [],
  TableCountRMiTLoading: false,
  //CIS
  StatusForCISData: [],
  StatusForCISLoading: false,
  ApplicationforCISData: [],
  ApplicationforCISLoading: false,
  ActionplanForCISData: [],
  ActionplanForCISLoading: false,
  TablelistlCISData: [],
  TablelistlCISLoading: false,
  TableCountCISData: [],
  TableCountCISLoading: false,
  //Onpremise
  AppliactionForOnpremiseData: [],
  AppliactionForOnpremiseLoading: false,
  AppliactionForRiskAssessmentData: [],
  AppliactionForRiskAssessmentLoading: false,
  StatusForOnpremiseData: [],
  StatusForOnpremiseLoading: false,
  StatusForRiskAssessmentData: [],
  StatusForRiskAssessmentLoading: false,
  ActionplanForonpremiseC9Data: [],
  ActionplanForonpremiseC9Loading: false,
  ActionplanForonpremiseRAData: [],
  ActionplanForonpremiseRALoading: false,
  OPCisoListApiData: [],
  OPCisoListApiLoading: false,
  RACisoListApiData: [],
  RACisoListApiLoading: false,
  OPCisoCountAPIData: [],
  OPCisoCountAPILoading: false,
  ApproveRejectC9OpData: [],
  ApproveRejectC9OpLoading: false,
  getDetailsofOnPremiseData: [],
  getDetailsofOnPremiseLoading: false,
  //IMI8 OnPremise
  AppliactionForOnpremiseIMI8Data: [],
  AppliactionForOnpremiseIMI8Loading: false,
  StatusForOnpremiseIMI8Data: [],
  StatusForOnpremiseIMI8Loading: false,
  ActionplanForonpremiseIMI8Data: [],
  ActionplanForonpremiseIMI8Loading: false,
  OPCisoListApiIMI8Data: [],
  OPCisoListApiIMI8Loading: false,
  RACisoListApiIMI8Data: [],
  RACisoListApiIMI8Loading: false,
  OPCisoCountAPIIMI8Data: [],
  OPCisoCountAPIIMI8Loading: false,
  ApproveRejectIMI8OpData: [],
  ApproveRejectIMI8OpLoading: false,
  getDetailsofOnPremiseIMI8Data: [],
  getDetailsofOnPremiseIMI8Loading: false,
};

export const CISOSlice = createSlice({
  name: "CISOSlice",
  initialState,
  reducers: {
    resetCISOSlice: () => initialState,
    resetCISOData: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, StatusForVulVm, "StatusForVulVmData");
    addApiCases(builder, AppliactionForVulVm, "AppliactionForVulVmData");
    addApiCases(builder, ActionPlanForVulVm, "ActionPlanForVulVmData");
    addApiCases(builder, TablelistlVm, "TablelistlVmData");
    addApiCases(builder, StatusForVulSHF, "StatusForVulSHFData");
    addApiCases(builder, AppliactionForVulShf, "AppliactionForVulShfData");
    addApiCases(builder, ActionplanForShf, "ActionplanForShfData");
    addApiCases(builder, TablelistlSHF, "TablelistlSHFData");
    addApiCases(builder, TableCountSHF, "TableCountSHFData");

    addApiCases(builder, StatusForVulBSP, "StatusForVulBSPData");
    addApiCases(builder, ApplicationForVulBSP, "ApplicationForVulBspData");
    addApiCases(builder, ActionplanForBSP, "ActionplanForBspData");
    addApiCases(builder, TablelistlBSP, "TablelistlBSPData");

    addApiCases(builder, StatusForTRMG, "StatusForTRMGData");
    addApiCases(builder, ApplicationFoTRMG, "ApplicationFoTRMGData");
    addApiCases(builder, ActionplanFoTRMG, "ActionplanFoTRMGData");
    addApiCases(builder, TablelistTRMG_C9, "TablelistTRMG_C9Data");
    addApiCases(builder, TableCountTRMG_C9, "TableCountTRMG_C9Data");
    addApiCases(builder, StatusForC9, "StatusForC9Data");
    addApiCases(builder, ApplicationforC9, "ApplicationforC9Data");
    addApiCases(builder, ActionplanForC9, "ActionplanForC9Data");
    addApiCases(builder, StatusForIMI8, "StatusForIMI8Data");
    addApiCases(builder, ApplicationforIMI8, "ApplicationforIMI8Data");
    addApiCases(builder, ActionplanForIMI8, "ActionplanForIMI8Data");
    addApiCases(builder, StatusForRMiT, "StatusForRMiTData");
    addApiCases(builder, ApplicationFoRMiT, "ApplicationFoRMiTData");
    addApiCases(builder, ActionplanFoRMiT, "ActionplanFoRMiTData");
    addApiCases(builder, TablelistRMiT, "TablelistRMiTData");
    addApiCases(builder, TableCountRMiT, "TableCountRMiTData");
    addApiCases(builder, StatusForCIS, "StatusForCISData");
    addApiCases(builder, ApplicationforCIS, "ApplicationforCISData");
    addApiCases(builder, ActionplanForCIS, "ActionplanForCISData");
    addApiCases(builder, TablelistlCIS, "TablelistlCISData");
    addApiCases(builder, TableCountCIS, "TableCountCISData");
    addApiCases(
      builder,
      AppliactionForOnpremise,
      "AppliactionForOnpremiseData"
    );
    addApiCases(
      builder,
      AppliactionForRiskAssessment,
      "AppliactionForRiskAssessmentData"
    );
    addApiCases(builder, StatusForOnpremise, "StatusForOnpremiseData");
    addApiCases(
      builder,
      StatusForRiskAssessment,
      "StatusForRiskAssessmentData"
    );
    addApiCases(
      builder,
      ActionplanForonpremiseC9,
      "ActionplanForonpremiseC9Data"
    );
    addApiCases(
      builder,
      ActionplanForonpremiseRA,
      "ActionplanForonpremiseRAData"
    );
    addApiCases(builder, OPCisoListApi, "OPCisoListApiData");
    addApiCases(builder, RACisoListApi, "RACisoListApiData");
    addApiCases(builder, OPCisoCountAPI, "OPCisoCountAPIData");
    addApiCases(builder, ApproveRejectC9Op, "ApproveRejectC9OpData");
    addApiCases(builder, getDetailsofOnPremise, "getDetailsofOnPremiseData");
    addApiCases(
      builder,
      AppliactionForOnpremiseIMI8,
      "AppliactionForOnpremiseIMI8Data"
    );
    addApiCases(builder, StatusForOnpremiseIMI8, "StatusForOnpremiseIMI8Data");
    addApiCases(
      builder,
      ActionplanForonpremiseIMI8,
      "ActionplanForonpremiseIMI8Data"
    );
    addApiCases(builder, OPCisoListApiIMI8, "OPCisoListApiIMI8Data");
    addApiCases(builder, RACisoListApiIMI8, "RACisoListApiIMI8Data");
    addApiCases(builder, OPCisoCountAPIIMI8, "OPCisoCountAPIIMI8Data");
    addApiCases(builder, ApproveRejectIMI8Op, "ApproveRejectIMI8OpData");
    addApiCases(
      builder,
      getDetailsofOnPremiseIMI8,
      "getDetailsofOnPremiseIMI8Data"
    );
  },
});

export const { resetCISOSlice, resetCISOData } = CISOSlice.actions;
export default CISOSlice.reducer;
